// extracted by mini-css-extract-plugin
export default {"image":"style_image__cQmai","primaryImg":"style_primaryImg__Q859Z","options":"style_options__jwPDT"};